(() => {
  function init(scope) {
    scope.querySelectorAll('.vm-spice').forEach(root => {
      if (root.dataset.vmReady) return;
      root.dataset.vmReady = 'true';
      const form = root.querySelector('form');
      const select = root.querySelector('[data-vm-variant]');
      if (!form || !select) return;
      // This form supplies product context to EasySell, never submits to Shopify checkout.
      form.addEventListener('submit', event => event.preventDefault());
      root.classList.add('vm-enhanced');
      const radios = [...root.querySelectorAll('input[name="vm_offer"]')];
      radios.forEach(radio => radio.addEventListener('change', () => {
        if (!radio.checked) return;
        select.value = radio.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      select.addEventListener('change', () => {
        radios.forEach(radio => { radio.checked = radio.value === select.value; });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url);
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();